import { render } from "./index.vue?vue&type=template&id=da3a35ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=da3a35ee&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3a35ee"],['__file',"src/views/settings/wewap/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da3a35ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da3a35ee', __exports__)) {
    console.log('reload')
    api.reload('da3a35ee', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=da3a35ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('da3a35ee', render)
  })

}


export default __exports__